import React from 'react';
import {render} from 'react-dom';

import { StickyContainer, Sticky }  from 'react-sticky';

var Fluxxor = require('fluxxor');
import { FluxMixin, StoreWatchMixin, flux } from './../flux'
import {wpImage}                    from './../wpImage'

import {NavigationBar}              from './NavigationBar.jsx';
import {Header}                     from './Header.jsx';
import {ActionBar}                  from './ActionBar.jsx';
import {GridView}                   from './GridView.jsx';
import {ListView}                   from './ListView.jsx';
import {Popup}                      from './Popup.jsx';
import {GridViewTransferAccept}     from './GridViewTransferAccept.jsx';
import {GridViewTransferRevoke}     from './GridViewTransferRevoke.jsx';
import {ListViewTransferAccept}     from './ListViewTransferAccept.jsx';
import {ListViewTransferRevoke}     from './ListViewTransferRevoke.jsx';

import {AlertPopup}                 from './DetailsPage/AlertPopup.jsx';
import {ClonePackagePopup}          from './DetailsPage/ClonePackagePopup.jsx';
import {CloneSuccessPopup}          from './DetailsPage/CloneSuccessPopup.jsx';
import {CloneWarningPopup}          from './DetailsPage/CloneWarningPopup.jsx';
import {TransferRevokePopup}        from './DetailsPage/TransferRevokePopup.jsx';


var Application = React.createClass({
  mixins: [wpImage, FluxMixin, StoreWatchMixin("MainStore")],
    getStateFromFlux: function() {
            var flux = this.getFlux();
                  return {
                            data                    : flux.store("MainStore").data,
                            packages                : flux.store("MainStore").data,
                            active                  : flux.store("MainStore").activeTheme,
                            updatesData             : flux.store("MainStore").updatesData,
                            errors                  : flux.store("MainStore").errors,
                            clonePackagePopup       : flux.store("MainStore").clonePackagePopup,
                            cloneSuccessPopup       : flux.store("MainStore").cloneSuccessPopup,
                            cloneWarningPopup       : flux.store("MainStore").cloneWarningPopup,
                            transferRevokePopup     : flux.store("MainStore").transferRevokePopup
                         }
    },
    getInitialState: function(){
    return {  listview        : false,
              gridview        : true,
              library         : "",
              sort            : "",
              addNew          : false,
              sortBy          : false,
              libSelect       : false,
              url             : "?page=Onboard",
              showPopup       : false,
              activeName      : "",
              addNewData      : ["Add New", "From the Marketplace", "Build from scratch", "Upload & Install"],
              addNewValue     : "Add New",
              cloneThemeSlug  : "" }
    },
    componentDidMount : function () {
        // this.getFlux().actions.getInitData();
        // var hostUrl = (window.location.href).split("wp-admin")[0];
        // hostUrl = hostUrl + "blended/v0";

        this.getFlux().actions.hostUrl = this.props.platform.hostUrl;        

        this.getFlux().actions.getUpdates();
        var lib = sessionStorage.getItem("lib")
        var sort = sessionStorage.getItem("sort");
        var listview = sessionStorage.getItem("listview");
        var gridview = sessionStorage.getItem("gridview");
        lib === "Shared with me" ?  this.getFlux().actions.getSharedPackages()  :  this.getFlux().actions.getInitData();
        if(lib){
          this.setState({library: lib});
        }else{
          this.setState({library: "All Packages"});
        }
        if(sort){
          this.setState({sort: sort});
        }else{
          this.setState({sort: "Sort By"})
        }
        if(JSON.parse(listview)){
          this.setState({listview : true, gridview: false}); 
        }else{
          this.setState({gridview : true, listview: false});
        }

        if(lib === "Shared with me" || lib === "My Purchases" || lib === "Archived Packages" || lib === "Pending Transfers"){
          this.setState({addNewValue: "Themes"});
          this.setState({addNewData: ["Themes", "Layouts","Code Snippets", "All Packages"]});
        }
  },
  onInputlist: function(value){
    this.setState({listview : value, gridview: !value}); // set the list view state and grid view to opposite state  (if list view is true then grid view is false and vice versa)
    sessionStorage.setItem("listview", value); 
  },
  onInputgrid: function(value){
    this.setState({gridview : value, listview: !value}); // // set the grid view state and list view to opposite state  (if grid view is true then list view is false and vice versa)
    sessionStorage.setItem("listview", !value); 
  },
  onLibrarySelect: function(value){
    this.setState({library: value}); // set the value of library (themes, layouts, themes groups ond all libraries)
    sessionStorage.setItem("lib", value);
    var themes =  ["Themes", "Layouts","Code Snippets", "All Packages"];
    var addNew =  ["Add New", "From the Marketplace", "Build from scratch", "Upload & Install" ];
    if(value === "Shared with me" || value === "My Purchases" || value === "Archived Packages" || value === "Pending Transfers"){
        this.setState({addNewData: themes});
        value === "Shared with me" ? this.getFlux().actions.getSharedPackages() : this.setState({data: {}, "packages": {}}) ; 
        if(this.state.library !== "Shared with me" || this.state.library != "My Purchases" || this.state.library != "Archived Packages" || this.state.library != "Pending Transfers"){
          this.setState({"addNewValue": "Themes"});
        }
    } else {
        this.getFlux().actions.getInitData();
        this.setState({addNewData: addNew});
        if(this.state.library === "Shared with me" || this.state.library === "My Purchases" || this.state.library === "Archived Packages" || this.state.library === "Pending Transfers"){
          this.setState({"addNewValue": "Add New"});
        }
    }
  },
  onSortChange: function(value){
    this.setState({sort: value});  // set the value of sortings.
    sessionStorage.setItem("sort", value); 
  },
  onChange: function(){
    /* if anything change without login, then it will
       redirected to blended on-board app  */
    if(localStorage.getItem("session_key") === null){
      window.location.href = this.state.url;
    }
  },
  makeActive: function(slug){
    this.getFlux().actions.makeActive(slug);  // call action when we click on active button
    // this.setState({active: slug})
  },
  showPreview: function(user, slug){
    this.getFlux().actions.showPreview(user, slug);
  },
  editTheme: function(slug, accountSlug, type){
    this.getFlux().actions.editTheme(slug, accountSlug, type);
  },
  handleContainerClick: function(){
    // if click on any where then all dropdowns will closed
    this.setState({addNew: false});
    this.setState({sortBy:false});
    this.setState({libSelect: false});
  },
  addNewDropdownShow: function(){
    this.setState({addNew: !this.state.addNew});
    this.setState({sortBy: false, libSelect: false});
  },
  sortBoxShow: function(){
    this.setState({sortBy: !this.state.sortBy});
    this.setState({addNew: false, libSelect: false});
  },
  libSelectShow: function(){
    this.setState({libSelect: !this.state.libSelect});
    this.setState({addNew: false, sortBy: false});
  },
  setAddNewValue: function(value){
    this.setState({addNewValue: value});
  },
  browse: function(slug){
    this.getFlux().actions.browse(slug);
  },
  libraryShow: function(data, library){
    /* it displays either themes or layouts or theme groups or all libraries based on user's input. */
      var lib,value1,flag =0;
      library = library.toUpperCase();
      if(library == "THEMES"){
        value1 = "theme"
        flag = 1;
      }
      else if(library == "LAYOUTS"){
        value1 = "VIEWLAYOUT"
        flag = 1;
      }
      else if(library == "THEME GROUPS"){
        value1 = "THEME_GROUP"
        flag = 1;
      } else if (library === "CODE SNIPPETS"){
        value1 = "CODE SNIPPETS"
        flag = 1;
      }
      if (flag == 1){
          lib = data.filter(function(item){
          return item["type"] === value1;
        });
      }
    else
        lib = data;

      return lib;
  },
  sortings : function(lib){
      /*Below are sorting Algorithms  */
                      /* 1. For Name */
        if(this.state.sort == "Name" || this.state.sort == "Sort By" ){
           lib.sort(function(a, b) {
              var nameA = a.name.split("/")[1].toUpperCase(); // ignore upper and lowercase
              var nameB = b.name.split("/")[1].toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              // names must be equal
              return 0;
            });

        }

        /*for rating */
        if(this.state.sort == "Rating"){
        lib.sort(function(a, b) {
            // a = a.rating_avg;
            // b = b.rating_avg;
            return b.rating_avg - a.rating_avg || a.name.split("/")[1].toUpperCase().localeCompare(b.name.split("/")[1].toUpperCase());;
        });
      }
      /* for last modified */
      if(this.state.sort == "Last Modified"){
        lib.sort(function(a,b){
            a = a.modified_date;
            b = b.modified_date;
            if(a != undefined){
            var a1 = "" + a.getFullYear() + a.getMonth() + a.getDate() + a.getTime()
          }
           if(b != undefined){
            var b1 = "" + b.getFullYear() + b.getMonth() + b.getDate() + b.getTime()
          }
            return b1-a1;
        });
      }
      /*  for date purchased */
       if(this.state.sort == "Date Purchased"){
        lib.sort(function(a,b){
            a = a.created_date;
            b = b.created_date;
            if(a != undefined){
            var a1 = "" + a.getFullYear() + a.getMonth() + a.getDate() + a.getTime();
          }
           if(b != undefined){
            var b1 = "" + b.getFullYear() + b.getMonth() + b.getDate() + b.getTime();
          }
            return b1-a1;
        });
      }
      return lib;
  },
  popup: function(value){
     /* if click on any button that will opens popup */
    // this.setState({showPopup: !this.state.showPopup});
    // this.setState({activeName: value})
    // this.makeActive(value);
  },
  version: function(label){
    /* clicked on submit button on version popup which entered label name */
    this.makeActive(this.state.activeName, label);
  },
  searchPackage: function(val){
    let lib = this.state.data.filter((value) =>{
        return value.name.indexOf(val) > -1
    });
    this.setState({packages: lib})
  },
  clone: function(action, newThemeName, newPackageName, accountSlug = "", slug = ""){
    this.getFlux().actions.clone(action, this.state.clonePackagePopup.accountSlug || accountSlug, this.state.clonePackagePopup.slug || slug, newThemeName, newPackageName);
  },
  alertPopup: function(){
    this.getFlux().actions.closeAlertPopup();
  },
  cloneSuccess: function(action){
    this.getFlux().actions.cloneSuccess(action, this.state.cloneSuccessPopup.accountSlug, this.state.cloneSuccessPopup.newSlug);        
  },
  cloneWarning: function(action){
    this.getFlux().actions.cloneWarning(action);
  },
  transferRevoke: function(action, accountSlug, slug){
    this.getFlux().actions.transferRevoke(action, accountSlug, slug);   
  },
  render: function(){
    if(this.state.data != undefined && this.state.data.length != undefined){
      var lib = this.libraryShow(this.state.packages, this.state.library); // it displays either themes or layouts or theme groups or all libraries based on user's input. 
      if(this.state.library ==="Shared with me" || this.state.library === "My Purchases" || this.state.library === "Archived Packages" || this.state.library === "Pending Transfers"){
        lib = this.libraryShow(this.state.packages, this.state.addNewValue);
      }
      lib = this.sortings(lib);  // sorts the library    
    }
    var marginTop  = "0px";
    // if(window.location.href.indexOf("admin") > -1){
    //     marginTop = "32px"
    // }
    var platform = this.props.platform;
    marginTop = platform.css.marginTop;
    var listgrid = null;
    var header = <Sticky style={{transform: "translateZ(90)", marginTop: marginTop}}>
                  <header>
                    <Header onInputlist = {this.onInputlist}
                            onInputgrid = {this.onInputgrid}
                            onLibrarySelect = {this.onLibrarySelect}
                            libSelect = {this.state.libSelect}
                            libSelectShow = {this.libSelectShow} 
                            library = {this.state.library}
                            gridview = {this.state.gridview}
                            listview = {this.state.listview}
                            searchPackage = {this.searchPackage} />
                  </header>
                </Sticky>;
    var actionbar = <ActionBar  onSortChange = {this.onSortChange}
                              addNew = {this.state.addNew}
                              sortBy = {this.state.sortBy}
                              addNewDropdownShow = {this.addNewDropdownShow}
                              sortBoxShow = {this.sortBoxShow}
                              sort = {this.state.sort}
                              addNewData = {this.state.addNewData}
                              setAddNewValue = {this.setAddNewValue}
                              addNewValue = {this.state.addNewValue} />;

    if(this.state.library !== "Pending Transfers"){
      listgrid =  <section className="content-section">
                  {header}
                <div className="content-container clearfix">
                    {actionbar}
                  {this.state.gridview  ?
                      <GridView
                          themes = {lib}
                          makeActive = {this.makeActive}
                          libName = {this.state.library}
                          showPreview = {this.showPreview}
                          editTheme = {this.editTheme}
                          active = {this.state.active}
                          popup = {this.popup}
                          clone = {this.clone}
                          browse = {this.browse}
                          addNewValue = {this.state.addNewValue} /> :
                      <ListView
                          themes = {lib}
                          makeActive = {this.makeActive}
                          libName = {this.state.library}
                          showPreview = {this.showPreview}
                          editTheme = {this.editTheme}
                          active = {this.state.active}
                          popup = {this.popup}
                          clone = {this.clone}
                          browse = {this.browse} 
                          addNewValue = {this.state.addNewValue} />
                    }
                </div>
              </section>
    } else {
       listgrid = <div>
            <section className="content-section">
                <Sticky style={{transform: "translateZ(90)", marginTop: marginTop}}>
                  {header}
                </Sticky>
                <div className="content-container clearfix container--joint">
                    {actionbar}
                  {this.state.gridview  ?
                      <GridViewTransferAccept
                          themes = {lib}
                          makeActive = {this.makeActive}
                          libName = {this.state.library}
                          showPreview = {this.showPreview}
                          editTheme = {this.editTheme}
                          active = {this.state.active}
                          popup = {this.popup}
                          clone = {this.clone}
                          browse = {this.browse}
                          addNewValue = {this.state.addNewValue} /> :
                      <ListViewTransferAccept
                          themes = {lib}
                          makeActive = {this.makeActive}
                          libName = {this.state.library}
                          showPreview = {this.showPreview}
                          editTheme = {this.editTheme}
                          active = {this.state.active}
                          popup = {this.popup}
                          clone = {this.clone}
                          browse = {this.browse} 
                          addNewValue = {this.state.addNewValue} />
                    }
                </div>
              </section>
              <section className="content-section">
                <div className="content-container clearfix">
                  {this.state.gridview  ?
                      <GridViewTransferRevoke
                          themes = {lib}
                          makeActive = {this.makeActive}
                          libName = {this.state.library}
                          showPreview = {this.showPreview}
                          editTheme = {this.editTheme}
                          active = {this.state.active}
                          popup = {this.popup}
                          clone = {this.clone}
                          browse = {this.browse}
                          addNewValue = {this.state.addNewValue} /> :
                      <ListViewTransferRevoke
                          themes = {lib}
                          makeActive = {this.makeActive}
                          libName = {this.state.library}
                          showPreview = {this.showPreview}
                          editTheme = {this.editTheme}
                          active = {this.state.active}
                          popup = {this.popup}
                          clone = {this.clone}
                          browse = {this.browse} 
                          addNewValue = {this.state.addNewValue} />
                    }
                </div>
              </section>
            </div>
    }
    return(
        <StickyContainer>
          <link rel="stylesheet" href={platform.style}/>
          <div className="container" onClick = {this.handleContainerClick}>
             <NavigationBar libName = {this.state.library} />
              {listgrid}

            {this.state.showPopup ?  
            <Popup popup = {this.popup}
                   version = {this.version} /> : null }

            {this.state.clonePackagePopup.popup ?
                  <ClonePackagePopup  clone = {this.clone}
                                      slug = {this.state.clonePackagePopup.slug}
                                      user = {this.state.clonePackagePopup.accountSlug}
                                      errors = {this.state.errors}
                                      closeAlertPopup = {this.alertPopup} /> : null }

            {this.state.errors.popup ?
                    <AlertPopup  alertPopup= {this.alertPopup} 
                                 errors = {this.state.errors} /> : null }

            {this.state.transferRevokePopup.popup ?
                    <TransferRevokePopup transferRevoke = {this.transferRevoke} /> : null }

            {this.state.cloneSuccessPopup.popup ?
                    <CloneSuccessPopup  cloneSuccess = {this.cloneSuccess} 
                                        themeName = {this.state.cloneSuccessPopup.newSlug}
                                        cloneSuccessPopup = {this.state.cloneSuccessPopup} 
                                        libName = {this.state.library} /> : null }

            {this.state.cloneWarningPopup.popup ?
                    <CloneWarningPopup cloneWarning = {this.cloneWarning}
                                       slug = {this.state.cloneWarningPopup.slug} /> : null }

          </div>
        </StickyContainer>
      );
  }
});

export {Application}


/** WEBPACK FOOTER **
 ** ./html/components/Application.jsx
 **/